import { render, staticRenderFns } from "./PreviewSwitch.vue?vue&type=template&id=26d7a3ce&"
import script from "./PreviewSwitch.vue?vue&type=script&lang=js&"
export * from "./PreviewSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports